import { z } from 'zod'
import { oc } from '@orpc/contract'

const enrichedRowSchema = z.object({
  name: z.string(),
  address: z.string().optional(),
  phone: z.string().optional(),
  fax: z.string().optional(),
  source: z.enum(['npi', 'ai', 'none']),
  sources: z
    .object({
      address: z.string().optional(),
      phone: z.string().optional(),
      fax: z.string().optional(),
    })
    .optional(),
})

const enrichmentSchema = z.object({
  providers: z.array(enrichedRowSchema),
  locations: z.array(enrichedRowSchema),
  generatedAt: z.string(),
  status: z.enum(['running', 'complete', 'failed']),
  progress: z.object({ completed: z.number(), total: z.number() }).optional(),
  /**
   * The patient has an encounter provider this enrichment never looked up, and
   * nothing is currently working on it — so the caller may refresh the provider
   * rows (refresh-providers). Reported rather than acted on, to keep this a read.
   */
  providersStale: z.boolean().optional(),
})

export const getRecordLocatorEnrichment = oc
  .route({ method: 'GET', path: '/v2/patients/{patientId}/record-locator' })
  .input(z.object({ patientId: z.string() }))
  .output(enrichmentSchema.nullable())
